import "./Logo.css";
import logo from "../../images/logo.png";

const Logo = () => {
  return <img className="header__logo" src={logo} alt="piggybank logo" />;
};
export default Logo;
